import React from "react";
import { lowerCase } from "lodash";

const defaultState = {
  categoryValue: "",
  displayCategoryOptions: false,
  selectedCategory: null,
  noteValue: null,
};

class NoteTagFilter extends React.Component {
  static defaultProps = {
    site: {},
    onError: () => console.error("Error in NoteTagCreate component."),
  };

  constructor(props) {
    super(props);

    this.state = { ...defaultState };
  }

  handleCategorySearch = (event) => {
    this.setState({ categoryValue: event.target.value });
  };

  onSelectCategory = (category) => {
    this.props.onSelect({
      category: category?.name,
      color: category?.color,
      note: "",
    });
    console.log("selecting", category);
    this.setState(
      {
        selectedCategory: category,
        categoryValue: "",
        noteValue: "",
        displayCategoryOptions: false,
      },
      () => {
        if (!category) {
          // this.categoryInput.focus();
        } else {
          this.noteInput.focus();
        }
      }
    );
  };

  renderCategoryOption = (category, onClick, style = {}) => {
    return (
      <div
        className={"category-option"}
        style={{ borderColor: category.color, color: category.color, ...style }}
        onClick={onClick ? onClick : () => this.onSelectCategory(category)}
      >
        {category.name}
      </div>
    );
  };

  handleNoteValueChange = (event) => {
    this.setState({ noteValue: event.target.value });
  };

  displayCategoryOptions = () => {
    return (
      <div className={"category-options"}>
        {this.props.categories
          .filter((d) => {
            return lowerCase(d.name).includes(
              lowerCase(this.state.categoryValue)
            );
          })
          .map((d) => this.renderCategoryOption(d))}
      </div>
    );
  };

  handleNoteSubmission = () => {
    let {
      selectedCategory: { name: category, color },
      noteValue: note,
    } = this.state;

    this.props.onSubmit({ category, note, color });
    this.reset();
  };

  reset = () => {
    this.setState({ ...defaultState });
  };

  render() {
    return (
      <div>
        <div className={"create-note-inputs"}>
          {!!this.state.selectedCategory && (
            <>
              <div style={{ height: "3.8em" }}>
                {this.renderCategoryOption(
                  this.state.selectedCategory,
                  () => this.onSelectCategory(null),
                  { margin: "0", marginRight: ".5em", fontSize: "1.3em" }
                )}
              </div>

              <input
                type={"text"}
                value={this.state.noteValue}
                ref={(x) => (this.noteInput = x)}
                placeholder={"Note Text to Add to Filter"}
                onChange={this.handleNoteValueChange}
                style={{ padding: "0 8px" }}
              />
              <button className="button" onClick={this.handleNoteSubmission}>
                Add Filter
              </button>
            </>
          )}
        </div>

        {!this.state.selectedCategory && this.displayCategoryOptions()}
      </div>
    );
  }
}

export default NoteTagFilter;
